$(function () {
  init_acf_carousel();
  init_equal_height_for_content();

  let resize_timeout;

  $(window).on('resize', () => {
    clearTimeout(resize_timeout);

    resize_timeout = setTimeout(() => {
      init_acf_carousel();
      init_equal_height_for_content();
    }, 150);
  });
});

function init_acf_carousel() {
  $('.acf-carousel__slider').each(function () {
    const $carousel = $(this);

    if ($carousel.hasClass('slick-initialized')) return;

    const slidesToShow = parseInt($carousel.data('slides-to-show'), 10) || 3;
    const centerPadding = $carousel.data('center-padding') || '16%';
    const showDots = Boolean($carousel.data('dots'));
    const landingLayout = Boolean($carousel.data('landing-layout'));
    const navArrow = Boolean($carousel.data('nav-arrow'));

    const landingSettings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      centerPadding: '0',
      adaptiveHeight: true,
    };

    $carousel.slick({
      infinite: true,
      slidesToShow: slidesToShow,
      slidesToScroll: 1,
      arrows: navArrow,
      dots: showDots,
      autoplay: false,
      speed: 500,
      autoplaySpeed: 5000,
      centerMode: true,
      centerPadding: centerPadding,
      rows: 0,
      responsive: [
        {
          breakpoint: 1024,
          settings: landingLayout
            ? {
                ...landingSettings,
                centerMode: true,
              }
            : {
                slidesToShow: 3,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '0',
              },
        },
        {
          breakpoint: 960,
          settings: landingLayout
            ? {
                ...landingSettings,
                centerMode: false,
              }
            : {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '0',
              },
        },
      ],
    });
  });
}

// Equal height for content (desktop only)
function init_equal_height_for_content() {
  if (window.innerWidth < 960) return;

  $('.acf-carousel__slider').each(function () {
    const $slider = $(this);

    if ($slider.closest('.acf-carousel__landing-page').length) return;

    const $contents = $slider.find('.acf-carousel__slider-content');

    if (!$contents.length) return;

    let maxHeight = 0;

    $contents.css('min-height', '');

    $contents.each(function () {
      maxHeight = Math.max(maxHeight, $(this).outerHeight());
    });

    if (maxHeight > 0) {
      $contents.css('min-height', `${maxHeight}px`);
    }
  });
}
